import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const Grid = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    return (
      <div {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Grid',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('DisplayGrid')),
  },
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'grid',
          gridAutoColumns: '1fr',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: 'auto auto',
          gridRowGap: '16px',
          gridColumnGap: '16px',
        },
      },
    },
  },

  render: Grid,
  fields: {children: TListOfElement},
});

export default config;
